module.exports = __webpack_public_path__ + "img/dice-4.5b45c811.svg";